module.exports = __webpack_public_path__ + "static/img/friend4.d398661.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/friend4.jpeg
// module id = 0CTF
// module chunks = 1